import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=c0b33a34"
import script from "./TableComponent.vue?vue&type=script&lang=ts"
export * from "./TableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports